"use strict";

APP.popups.PausePopup = function ( p_fromPauseButton ) {

    // Invoke (needed)
    EHDI.aka.Container.call( this );

    // ** Parent (This reference)
    var _parent = this;
    
    // ** General Values
    var _action, _filePaths, _fromPauseButton, 
    _maxPages, _messages, _pageNumber;

    // ** Graphics
    var _btnAudio, _btnExit, _btnReturn, _btnNext, _btnPrev, 
    _sprBG, _sprOverlay, _sprPageCurrent, _sprPageNext, _txtHeader, _timelinePage;

    // Private Methods
    
    /**
     * Exit game (return to title screen)
     */
    var _exitGame = function () {

        // Send pause button isEndGame to true
        APP.game.btnPause.isEndGame = true;

        // Remove this popup
        APP.managers.scene.popPopUp();

        // Change scene
        APP.managers.scene.changeScene( new APP.scenes.TitleScene(), { alpha : new EHDI.scene.TransitionParameter( 0,1 ), duration : 0.25});
    };

    /**
     * End transition
     */
    var _endTransition = function () {

        if ( _sprPageCurrent ) _sprPageCurrent.destroy( { children: true } );
        _sprPageCurrent = _sprPageNext;
        _sprPageNext = null;
        _sprPageCurrent.alpha = 1;    
    }

    /**
     * Move page.
     * @param {*Number} p_direction Direction of which page to go next. 1 or -1 only.
     */
    var _movePage = function( p_direction ) {

        // Check param value is valid then throw error
        if ( p_direction !== 1 &&
            p_direction !== -1 ) throw "Invalid direction for move page. 1 or -1 only.";
        
        // Check if values are invalid, then return
        if ( !_sprBG ) return;
        if ( typeof _pageNumber !== "number" ) return;

        // Play button sfx
        APP.managers.sound.playSFX( "button_sfx" );
        
        // Kill transition
        if ( _timelinePage ) _timelinePage.kill();

        // If next page value is not empty, end transition
        if( _sprPageNext ) _endTransition();
        
        _sprPageNext = new EHDI.aka.Container();
        _sprPageNext.alpha = 0;
        _pageNumber += p_direction;
        
        // Clamp page index   
        if(_pageNumber < 1)
            _pageNumber = _maxPages;
        else if(_pageNumber > _maxPages)
            _pageNumber = 1;

        // Create page image
        var sprImage = new EHDI.aka.Sprite( EHDI.Assets.images[ _filePaths[ _pageNumber - 1 ] ] );
        sprImage.anchor.set( 0.5, 0.5 );
        sprImage.position.set( 0, -_sprBG.height * 0.15 );
        _sprPageNext.addChild( sprImage );
        
        // Create text content
        var sprContent = _messages[ _pageNumber -1 ];
        var txtContent = new EHDI.displays.TextSprite(sprContent);
        txtContent.style.wordWrap = true;
        txtContent.style.wordWrapWidth = sprImage.width * 0.95;

        txtContent.anchor.set( 0.5, 0 );
        txtContent.position.set( 0, _sprBG.height * 0.05 );
        _sprPageNext.addChild( txtContent );
        
        _timelinePage = new TimelineMax();
        _timelinePage.to( _sprPageNext, 0.5, { alpha : 1 } );
        _timelinePage.to( _sprPageCurrent, 0.5, { alpha : 0 }, 0 );
        _timelinePage.add( _endTransition );

        _sprBG.addChild( _sprPageNext );
    };

    // ** Handler

    /**
     * Handler for audio button.
     * @param {*Boolean} p_enable Value if enabled.
     */
    var _handler_btnAudio = function ( p_enable ) {

        // Set mute to sound manager
        APP.managers.sound.setMute( p_enable );

        // Save to storage
        APP.save.isMuted = p_enable;
        APP.managers.storage.setLocalInfo( APP.config.id, APP.save );

        // Play sfx when enabled
        if ( APP.save.isMuted === false ) APP.managers.sound.playSFX( "button_sfx" );
    };

    /**
     * Handler for exit button.
     */
    var _handler_btnExit = function () {

        // Play button sfx
        APP.managers.sound.playSFX( "button_sfx" );

        // Add confirmation popup
        APP.managers.scene.pushPopUp( new APP.popups.ConfirmationPopup( _exitGame, null ), {y : new EHDI.scene.TransitionParameter( APP.config.stageHeight, 0 ), duration : 0.25 } );
    };

    /**
     * Handler for return button.
     */
    var _handler_btnReturn = function () {

        // Play button sfx
        APP.managers.sound.playSFX( "button_sfx" );

        // Remove popup
        APP.managers.scene.popPopUp( { y : new EHDI.scene.TransitionParameter( APP.config.stageHeight * 0.5, -APP.config.stageHeight ), duration : 0.25 } );

    };

    /**
     * Handler for next button.
     */
    var _handler_btnNext = function () { _movePage( 1 ); };

    /**
     * Handler for prev button.
     */
    var _handler_btnPrev = function () { _movePage( -1 ); };

    // ** Initialization Methods

    /**
     * Initialize properties
     * @param {*Boolean} p_fromPauseButton If popup was invoked by pause button.
     */
    var _initProps = function ( p_fromPauseButton ) {

        // Chek param values is invalid, then throw error
        if ( p_fromPauseButton !== true &&
            p_fromPauseButton !== false ) throw "fromPauseButton value should be boolean.";

        // Initialize values
        _fromPauseButton = p_fromPauseButton;
        _pageNumber = 1;


      

        if ( EHDI.BrowserInfo.isMobileDevice )
        {
            _messages = [
                APP.managers.json.getLocale("STR_HTP_0"),
                APP.managers.json.getLocale("STR_HTP_1"),
                APP.managers.json.getLocale("STR_HTP_2"),
                APP.managers.json.getLocale("STR_HTP_3"),
                APP.managers.json.getLocale("STR_HTP_4_MOBILE"),
                APP.managers.json.getLocale("STR_HTP_5"),
                APP.managers.json.getLocale("STR_HTP_6")
            ];
        }
        else
            {
                _messages = [
                    APP.managers.json.getLocale("STR_HTP_0"),
                    APP.managers.json.getLocale("STR_HTP_1"),
                    APP.managers.json.getLocale("STR_HTP_2"),
                    APP.managers.json.getLocale("STR_HTP_3"),
                    APP.managers.json.getLocale("STR_HTP_4_DESKTOP"),
                    APP.managers.json.getLocale("STR_HTP_5"),
                    APP.managers.json.getLocale("STR_HTP_6")
                ];
            }

        _filePaths = [
            "assets/ui/htp_separate1.png",
            "assets/ui/htp_separate2.png",
            "assets/ui/htp_separate3.png",
            "assets/ui/htp_separate4.png",
            "assets/ui/htp_separate5.png",
            "assets/ui/htp_separate6.png",
            "assets/ui/htp_separate7.png"
        ];

        _maxPages = _filePaths.length;
    };

    /**
     * Initialize graphics.
     */
    var _initGraphics = function () {

        // Set parent position
        if ( _parent ) {
            
            _parent.x = APP.config.stageWidth * 0.5;
            _parent.y = APP.config.stageHeight * 0.5;
        }

        if ( !_sprOverlay ) {

            _sprOverlay =  EHDI.displays.FillRectangle( 0x000000, 0, 0, APP.config.stageWidth, APP.config.stageHeight, 0 );
            _sprOverlay.alpha = 0.5;
            _sprOverlay.anchor.set( 0.5, 0.5 );
            _sprOverlay.interactive = true;

            if ( _parent ) _parent.addChild( _sprOverlay );
        }

        if ( !_sprBG ) {

            _sprBG = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_pop.png" ] );
            _sprBG.anchor.set( 0.5, 0.5 );

            if ( _parent ) _parent.addChild( _sprBG );
        }

        if ( !_txtHeader ) {

            var strHeader;

            if(this.fromPauseBtn){
                strHeader = APP.managers.json.getLocale("STR_PAUSED");
            }
            else{
                strHeader = APP.managers.json.getLocale("STR_HTP");
            }
            _txtHeader = new EHDI.displays.TextSprite(strHeader);
            _txtHeader.anchor.set( 0.5, 0.5 );

            _txtHeader.position.set( -_sprBG.width * 0.2, -_sprBG.width * 0.24 );
            _sprBG.addChild( _txtHeader );
        }
        
        if ( !_sprPageCurrent ) {

            _sprPageCurrent = new EHDI.aka.Container();

            _sprBG.addChild( _sprPageCurrent );
        
            var sprImage = new EHDI.aka.Sprite( EHDI.Assets.images[ _filePaths[ 0 ] ] );
            sprImage.anchor.set( 0.5, 0.5 );
            sprImage.position.set( 0, -_sprBG.height * 0.15 );

            _sprPageCurrent.addChild( sprImage );

            var txtContent = new EHDI.displays.TextSprite(_messages[0]);
            txtContent.style.wordWrap = true;
            txtContent.style.wordWrapWidth = sprImage.width * 0.95;
            txtContent.anchor.set( 0.5, 0 );
            txtContent.position.set( 0, _sprBG.height * 0.05 );

            _sprPageCurrent.addChild( txtContent );
        }

        if ( !_btnNext ) {

            _btnNext = new EHDI.displays.Button( EHDI.Assets.images[ "assets/ui/btn_prevnext.png" ], 
                                                EHDI.Assets.images[ "assets/ui/btn_prevnext2.png" ], null, null);
    
            _btnNext.position.set( _sprBG.width * 0.45, 0 );
            _btnNext.setOnClickFunction( _handler_btnNext );
            
            _sprBG.addChild( _btnNext );
        }

        if ( !_btnPrev ) {

            _btnPrev = new EHDI.displays.Button( EHDI.Assets.images[ "assets/ui/btn_prevnext.png" ], 
                                                EHDI.Assets.images[ "assets/ui/btn_prevnext2.png" ], null, null);
    
            _btnPrev.position.set( -_sprBG.width * 0.45, 0 );
            _btnPrev.scale.x = -1;
            _btnPrev.setOnClickFunction( _handler_btnPrev );
            
            _sprBG.addChild( _btnPrev );
        }

        if ( !_btnReturn ) {

            _btnReturn = new EHDI.displays.Button( EHDI.Assets.images[ "assets/ui/btn_return.png" ], 
                                                EHDI.Assets.images[ "assets/ui/btn_return2.png" ], null, null);
    
            _btnReturn.position.set( 0, _sprBG.height * 0.35 );
            _btnReturn.setOnClickFunction( _handler_btnReturn );
            
            _sprBG.addChild( _btnReturn );
        }

        

        if ( _fromPauseButton == true ) {

            if ( !_btnExit ) {

                _btnExit = new EHDI.displays.Button( EHDI.Assets.images[ "assets/ui/btn_exit.png" ], 
                                                    EHDI.Assets.images[ "assets/ui/btn_exit2.png" ], null, null);
        
                _btnExit.position.set( -_sprBG.width * 0.3, _sprBG.height * 0.35 );
                _btnExit.setOnClickFunction( _handler_btnExit );
                
                _sprBG.addChild( _btnExit );
            }

            if ( !_btnAudio ) {

               _btnAudio = new EHDI.displays.ToggleButton( EHDI.Assets.images[ "assets/ui/btn_audio1.png" ], 
                                                        EHDI.Assets.images[ "assets/ui/btn_audio3.png" ], 
                                                        EHDI.Assets.images[ "assets/ui/btn_audio2.png" ], 
                                                        EHDI.Assets.images[ "assets/ui/btn_audio4.png" ], 
                                                        APP.managers.sound.getMuted() );
                _btnAudio.position.set( _sprBG.width * 0.3, _sprBG.height * 0.35 );
                _btnAudio.setOnClickFunction( _handler_btnAudio );
                
                _sprBG.addChild( _btnAudio );
            }
        }
    };

    /**
     * Initialize listeners.
     */
    var _initListeners = function () { };

    // ** Kill Methods

    /**
     * Kill properties.
     */
    var _killProps = function () {

        // Kill properties
        _parent = null;
        _action = null;
        if ( _filePaths ) {

            for ( var i = 0; i < _filePaths.length; i++ ) {

                _filePaths[ i ] = null;
            }
        }
        _filePaths = null;
        _fromPauseButton = null;
        _maxPages = null;

        if ( _messages ) {

            for ( var i = 0; i < _messages.length; i++ ) {

                _messages[ i ] = null;
            }
        }
        _messages = null;
        _pageNumber = null;

    };

    /**
     * Kill graphics.
     *  
     */
    var _killGraphics = function () {

        var i = 0;

        // ** Kill timelines
        if ( _timelinePage ) {

            _timelinePage.stop();
            _timelinePage.kill();
        }
        _timelinePage = null;

        // ** Kill texts
        if ( _txtHeader ) {
            
            if ( _txtHeader.parent ) _txtHeader.parent.removeChild( _txtHeader );

            _txtHeader.destroy( { children: true } );
        }
        _txtHeader = null;

        // ** Kill buttons

        if ( _btnAudio ) {
            
            _btnAudio.setOnClickFunction( null );
            if ( _btnAudio.parent ) _btnAudio.parent.removeChild( _btnAudio );

            _btnAudio.destroy( { children: true } );
        }
        _btnAudio = null;

        if ( _btnExit ) {
            
            _btnExit.setOnClickFunction( null );
            if ( _btnExit.parent ) _btnExit.parent.removeChild( _btnExit );

            _btnExit.destroy( { children: true } );
        }
        _btnExit = null;

        if ( _btnReturn ) {
            
            _btnReturn.setOnClickFunction( null );
            if ( _btnReturn.parent ) _btnReturn.parent.removeChild( _btnReturn );

            _btnReturn.destroy( { children: true } );
        }
        _btnReturn = null;

        if ( _btnNext ) {
            
            _btnNext.setOnClickFunction( null );
            if ( _btnNext.parent ) _btnNext.parent.removeChild( _btnNext );

            _btnNext.destroy( { children: true } );
        }
        _btnNext = null;

        if ( _btnPrev ) {
            
            _btnPrev.setOnClickFunction( null );
            if ( _btnPrev.parent ) _btnPrev.parent.removeChild( _btnPrev );

            _btnPrev.destroy( { children: true } );
        }
        _btnPrev = null;

        // ** Kill sprite

        if ( _sprPageCurrent ) {
            
            if ( _sprPageCurrent.parent ) _sprPageCurrent.parent.removeChild( _sprPageCurrent );

            _sprPageCurrent.destroy( { children: true } );
        }
        _sprPageCurrent = null;

        if ( _sprPageNext ) {
            
            if ( _sprPageNext.parent ) _sprPageNext.parent.removeChild( _sprPageNext );

            _sprPageNext.destroy( { children: true } );
        }
        _sprPageNext = null;

        if ( _sprBG ) {
            
            if ( _sprBG.parent ) _sprBG.parent.removeChild( _sprBG );

            _sprBG.destroy( { children: true } );
        }
        _sprBG = null;

        if ( _sprOverlay ) {
            
            if ( _sprOverlay.parent ) _sprOverlay.parent.removeChild( _sprOverlay );

            _sprOverlay.destroy( { children: true } );
        }
        _sprOverlay = null;
    };

    /**
     * Kill listeners.
     */
    var _killListeners = function () { };

    // Public Methods

    // ** Popup Methods
    this.popUpWillAppear = function () { };

    this.popUpDidAppear = function () { };

    this.popUpWillDisappear = function() { if ( _sprOverlay ) _sprOverlay.alpha = 0; };

    this.popUpDidDisappear = function () { 
        
        if ( APP.game.btnPause ) APP.game.btnPause.resumeGame();

        this.destroy( { children: true } );
    };

    // ** Destroy 
    this.destroy = function () {
        
        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();

        // Kill props
        _killProps();

        // Call superclass method
        APP.popups.PausePopup.prototype.destroy.apply( this, arguments );
    };

    // Call init methods
    _initProps( p_fromPauseButton );
    _initGraphics();
    _initListeners();

    Object.defineProperties( _parent, {
        "overlay": {
            get: function () { return _sprOverlay; },
            enumerable: true
        },
    });
    
    // Return parent
    return _parent;
}
APP.popups.PausePopup.prototype = Object.create( EHDI.aka.Container.prototype );
APP.popups.PausePopup.prototype.constructor = APP.popups.PausePopup;